import Vue from 'vue'

const state = {
	online: true
}

const getters = {
	isOnline: state => state.online,
	isOffline: state => !state.online,
}

const mutations = {
	goOnline: (state) => {
		state.online = true
  	},
  	goOffline: (state) => {
		state.online = false
  	},
}

export default {
	state,
	getters,
	mutations,
}